import NeoCard from "design/design_components/neo/panel/NeoCard.base";
import NeoInnerTitle from "design/design_components/neo/title/NeoInnerTitle.base";
import NeoColumn from "design/design_components/neo/layout/NeoColumn.base";
import NeoDataSecond from "design/design_components/neo/data/NeoDataSecond.base";
import NeoButtonMain from "design/design_components/neo/button/NeoButtonMain.base";
import { URLS_NEOADM } from "consts/neoadm";

const formateaTelefono = (telefono) => {
    const digitos = `${telefono ?? ''}`.replace(/\D/g, '');
    return digitos.length === 10
        ? `(${digitos.slice(0, 2)}) ${digitos.slice(2, 6)}-${digitos.slice(6)}`
        : telefono;
};

/**
 * Los datos personales viven en NeoAdmin y solo se editan ahí; aquí se
 * consultan y hay un acceso directo para editarlos. La usan el cliente (sus
 * datos) y el ejecutivo (los datos del cliente que está viendo).
 *
 * Una subcuenta ve los datos de la cuenta principal, pero en NeoAdmin edita los
 * suyos, por eso a ella no se le muestran los datos, solo el acceso.
 *
 * @param {{ datos: object, esSubCuenta?: boolean, vistaEjecutivo?: boolean }} props
 */
const TarjetaDatosPersonales = (props) => {
    const datos = props.datos ?? {};
    const nombreCompleto = `${datos.nombre ?? ''} ${datos.apellido ?? ''}`.trim();

    // Mismo botón corto para ambos; el destino va en el tooltip.
    // Al cliente nunca se le dice "NeoAdmin" (nombre interno); al ejecutivo sí
    const textos = props.vistaEjecutivo
        ? { titulo: 'Datos de la cuenta', destino: 'Se abre en NeoAdmin' }
        : { titulo: 'Tus datos personales', destino: 'Se abre tu cuenta NeoRed' };

    const abrirEdicion = () => {
        const url = props.vistaEjecutivo
            ? URLS_NEOADM.cuentaCliente(datos.uidauth)
            : URLS_NEOADM.miCuenta();

        window.open(url, '_blank', 'noopener,noreferrer');
    };

    return (
        <NeoCard>
            {/* Bloque de 10: título y datos (en su propia grilla); bloque de 2: la acción */}
            <NeoColumn md="10" col="12" extra="p-p-0">
                <div className="p-grid p-m-0">
                    <NeoInnerTitle extra="primero">{textos.titulo}</NeoInnerTitle>

                    {props.esSubCuenta ? (
                        <NeoColumn col="12">
                            Tus datos personales se administran desde tu cuenta NeoRed.
                        </NeoColumn>
                    ) : (<>
                        {/* overflow-wrap: un correo o empresa largos se cortan dentro de su columna en vez de encimarse */}
                        <NeoColumn md="3" col="12">
                            <div style={{ overflowWrap: 'anywhere' }}>
                                <NeoDataSecond fact={nombreCompleto || '—'} label="Nombre" />
                            </div>
                        </NeoColumn>
                        <NeoColumn md="3" col="12">
                            <div style={{ overflowWrap: 'anywhere' }}>
                                <NeoDataSecond fact={datos.correo || '—'} label="Correo electrónico" />
                            </div>
                        </NeoColumn>
                        <NeoColumn md="3" col="12">
                            <div style={{ overflowWrap: 'anywhere' }}>
                                <NeoDataSecond fact={formateaTelefono(datos.telefono) || '—'} label="Teléfono" />
                            </div>
                        </NeoColumn>
                        <NeoColumn md="3" col="12">
                            <div style={{ overflowWrap: 'anywhere' }}>
                                <NeoDataSecond fact={datos.empresa || '—'} label="Empresa" />
                            </div>
                        </NeoColumn>
                    </>)}
                </div>
            </NeoColumn>

            <NeoColumn md="2" col="12" extra="p-d-flex p-ai-center p-jc-end">
                <NeoButtonMain
                    label="Editar"
                    icon="pi pi-external-link"
                    iconPos="right"
                    tooltip={textos.destino}
                    tooltipOptions={{ position: 'top' }}
                    aria-label={`Editar. ${textos.destino}`}
                    disabled={props.vistaEjecutivo && !datos.uidauth}
                    onClick={abrirEdicion}
                />
            </NeoColumn>
        </NeoCard>
    );
};

export default TarjetaDatosPersonales;
